/* ==========================================================================
   LUJE — hide product cards whose matching variant is sold out, when a
   shopper has an option filter (size, color, ...) active.

   THE GAP THIS FILLS
   Shopify's own collection.filters match a product if it HAS a variant with
   the selected option value at all — not if that variant is currently in
   stock. Filtering "Size: M" still returns a product whose M sold out weeks
   ago, as long as some other size still sells. Shopify's filtering has no
   "and it's actually available" mode, and this is computed server-side, so
   it cannot be fixed by changing what the server returns. This runs after
   the fact, client-side, on whatever the server already sent back.

   HOW IT KNOWS WHAT'S AVAILABLE
   snippets/product-card.liquid emits one <script type="application/json"
   data-luje-variant-availability="{{ product.id }}"> per card: the option
   combinations (lowercased option names, e.g. {"size":"M","color":"White"})
   of that product's currently-purchasable variants. Nothing here talks to
   the network; it only reads what the server already rendered.

   WHEN IT RUNS
   Active filters live in the URL query string (filter.v.option.<name>=...),
   which 2.0-filters.min.js keeps in sync via history.pushState on every
   render — so it is the one source of truth that is current immediately
   after a swap, without racing the querystring update. A MutationObserver on
   #CollectionProductGrid re-runs this after every AJAX re-render, the same
   pattern luje-filter-drawer.js uses for the sidebar swap.

   WHAT IT DELIBERATELY DOES NOT DO
   - Touch the filter option counts ("Size M (12)") — that needs the same
     per-product data aggregated across the WHOLE collection, not just the
     current page of cards, which this file only ever sees. That's
     luje-filter-counts.js, a separate bulk fetch (capped by collection size,
     since this store also carries some much larger legacy collections),
     rather than folded in here.
   - Hide anything when no option filter is active. A product with an
     entirely sold-out size is still a real product; only the combination of
     "you asked for a size" and "this one doesn't have it" hides a card.
   ========================================================================== */
(function () {
  'use strict';

  var GRID = '#CollectionProductGrid';
  var CARD = '.sf__pcard';
  var HIDDEN_CLASS = 'luje-unavailable-filtered';

  function activeOptionFilters() {
    var params = new URLSearchParams(window.location.search);
    var byName = {};
    params.forEach(function (value, key) {
      var m = /^filter\.v\.option\.(.+)$/.exec(key);
      if (!m) return;
      var name = m[1];
      (byName[name] || (byName[name] = [])).push(value);
    });
    return byName;
  }

  function availabilityFor(productId) {
    var el = document.querySelector('[data-luje-variant-availability="' + CSS.escape(String(productId)) + '"]');
    if (!el) return null;
    try { return JSON.parse(el.textContent || '[]'); } catch (e) { return null; }
  }

  /* True if some available variant satisfies every active option group at
     once — the same "one variant, all constraints" matching Shopify's own
     combined filters use, with the missing availability check added. */
  function hasMatchingAvailableVariant(variants, filters, names) {
    for (var i = 0; i < variants.length; i++) {
      var entry = variants[i];
      var ok = true;
      for (var j = 0; j < names.length; j++) {
        var name = names[j];
        if (filters[name].indexOf(entry[name]) === -1) { ok = false; break; }
      }
      if (ok) return true;
    }
    return false;
  }

  function run() {
    var grid = document.querySelector(GRID);
    if (!grid) return;

    var filters = activeOptionFilters();
    var names = Object.keys(filters);
    if (!names.length) {
      /* No option filter active: nothing to enforce. Clear any leftover
         hidden state from a previous, now-cleared filter. */
      var shown = grid.querySelectorAll('.' + HIDDEN_CLASS);
      for (var k = 0; k < shown.length; k++) shown[k].classList.remove(HIDDEN_CLASS);
      return;
    }

    var cards = grid.querySelectorAll(CARD);
    for (var c = 0; c < cards.length; c++) {
      var card = cards[c];
      var form = card.querySelector('form[data-product-id]');
      var productId = form && form.getAttribute('data-product-id');
      if (!productId) continue;

      var variants = availabilityFor(productId);
      /* No data for this product (shouldn't happen; product-card.liquid
         always emits it) — leave it as Shopify rendered it rather than
         guessing. */
      if (!variants) continue;

      var matches = hasMatchingAvailableVariant(variants, filters, names);
      /* Hide the column wrapper (.sf__col-item), not the card: the grid is a
         flex-wrap row of fixed-width columns (see
         main-collection-product-grid.liquid), and .sf__pcard is the content
         inside that column. Hiding just the card leaves its column's width
         empty in the row instead of letting the next card reflow into it. */
      (card.closest('.sf__col-item') || card).classList.toggle(HIDDEN_CLASS, !matches);
    }
  }

  function watch() {
    new MutationObserver(function (muts) {
      var swapped = muts.some(function (m) {
        return [].slice.call(m.addedNodes).some(function (n) {
          return n.nodeType === 1 && (n.matches && n.matches(GRID) || n.querySelector && n.querySelector(GRID));
        });
      });
      if (swapped) run();
    }).observe(document.body, { childList: true, subtree: true });

    /* Covers back/forward navigation, which 2.0-filters.min.js also
       re-renders from onHistoryChange rather than a full page load. */
    window.addEventListener('popstate', function () { setTimeout(run, 60); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); watch(); });
  } else {
    run(); watch();
  }
})();
